import { useCallback, useContext } from "react";
import { useUrlQueryForActiveIssueId } from "@adsk/acc-issues-core/utils/hooks/queryParams";
import { PanelType } from "./PanelType";
import { ActivePanelTypeContext } from "./IssuesPanel/ActivePanelTypeContext";

export const useCurrentRightPanel = () => {
  const { activeIssueId, setActiveIssueId } = useUrlQueryForActiveIssueId();
  const [activePanelType, setActivePanelType] = useContext(
    ActivePanelTypeContext
  );

  const activateIssueDetailPanel = useCallback(
    (issueId?: string) => {
      setActiveIssueId(issueId);
      setActivePanelType(issueId ? PanelType.IssueDetailPanel : PanelType.None);
    },
    [setActiveIssueId, setActivePanelType]
  );

  const closePanel = useCallback(() => {
    setActiveIssueId(undefined);
    setActivePanelType(PanelType.None);
  }, [setActiveIssueId, setActivePanelType]);

  const toggleFilterPanel = useCallback(() => {
    setActiveIssueId(undefined);
    setActivePanelType(
      activePanelType === PanelType.FilterPanel
        ? PanelType.None
        : PanelType.FilterPanel
    );
  }, [setActivePanelType, setActiveIssueId, activePanelType]);

  const toggleExportPanel = useCallback(() => {
    setActiveIssueId(undefined);
    setActivePanelType(
      activePanelType === PanelType.ExportPanel
        ? PanelType.None
        : PanelType.ExportPanel
    );
  }, [setActiveIssueId, activePanelType, setActivePanelType]);

  const toggleBulkEditPanel = useCallback(() => {
    setActiveIssueId(undefined);
    setActivePanelType(
      activePanelType === PanelType.BulkEditPanel
        ? PanelType.None
        : PanelType.BulkEditPanel
    );
  }, [setActiveIssueId, activePanelType, setActivePanelType]);

  return {
    activeIssueId,
    activePanelType,
    activateIssueDetailPanel,
    toggleFilterPanel,
    toggleExportPanel,
    toggleBulkEditPanel,
    closePanel,
  };
};
